import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, vModelSelect as _vModelSelect, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4797bfae"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home" }
const _hoisted_2 = {
  key: 0,
  class: "taskWrapper d-flex flex-row"
}
const _hoisted_3 = { class: "taskId" }
const _hoisted_4 = { class: "col-auto" }
const _hoisted_5 = { class: "whole-task" }
const _hoisted_6 = { class: "taskContent" }
const _hoisted_7 = {
  key: 0,
  class: "form-check form-switch"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "editswitch"
}, "Enable Editing", -1))
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "task-header" }
const _hoisted_11 = { class: "row" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_14 = ["disabled"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_16 = { class: "task-details" }
const _hoisted_17 = { class: "row" }
const _hoisted_18 = { class: "row py-2" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col col-4" }, " Priority : ", -1))
const _hoisted_20 = { class: "col col-8" }
const _hoisted_21 = { class: "row py-2" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col col-4" }, " Job Name : ", -1))
const _hoisted_23 = { class: "col col-8" }
const _hoisted_24 = { class: "row py-2" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col col-4" }, " Created By : ", -1))
const _hoisted_26 = {
  key: 0,
  class: "col col-8"
}
const _hoisted_27 = { class: "row py-2" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col col-4" }, " Started By : ", -1))
const _hoisted_29 = {
  key: 0,
  class: "col col-8"
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_31 = { class: "row py-2" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col col-4" }, " Assigned To : ", -1))
const _hoisted_33 = { class: "col col-8" }
const _hoisted_34 = { class: "float-end" }
const _hoisted_35 = ["checked", "onChange", "id"]
const _hoisted_36 = ["for"]
const _hoisted_37 = { class: "row" }
const _hoisted_38 = { class: "row py-2" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col col-4" }, " Work Center : ", -1))
const _hoisted_40 = { class: "col col-8" }
const _hoisted_41 = ["disabled"]
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: null }, [
  /*#__PURE__*/_createElementVNode("em", null, "None")
], -1))
const _hoisted_43 = ["value"]
const _hoisted_44 = { class: "row py-2" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col col-4" }, " Expected Start Date : ", -1))
const _hoisted_46 = { class: "col col-8" }
const _hoisted_47 = { class: "row py-2" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col col-4" }, " Start Date : ", -1))
const _hoisted_49 = { class: "col col-8" }
const _hoisted_50 = { class: "row py-2" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col col-4" }, " Expected Conclusion Date : ", -1))
const _hoisted_52 = { class: "col col-8" }
const _hoisted_53 = { class: "row py-2" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col col-4" }, " Concluded Date : ", -1))
const _hoisted_55 = { class: "col col-8" }
const _hoisted_56 = { class: "row py-2" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col col-4" }, [
  /*#__PURE__*/_createTextVNode(" Man Hours"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("(HH/MM/SS) : ")
], -1))
const _hoisted_58 = { class: "col col-8" }
const _hoisted_59 = {
  key: 0,
  class: "row py-2"
}
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col col-4" }, " Total Cost : ", -1))
const _hoisted_61 = { class: "col col-8" }
const _hoisted_62 = { class: "row actionButtons" }
const _hoisted_63 = {
  key: 0,
  class: "btn btn-primary",
  disabled: ""
}
const _hoisted_64 = {
  key: 1,
  class: "alert alert-success rounded",
  disabled: ""
}
const _hoisted_65 = {
  key: 2,
  class: "alert alert-danger rounded",
  disabled: ""
}
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_67 = {
  key: 0,
  class: "task-action"
}
const _hoisted_68 = { key: 0 }
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Active Task", -1))
const _hoisted_70 = {
  key: 0,
  class: "timer"
}
const _hoisted_71 = { key: 1 }
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "No Active Task", -1))
const _hoisted_73 = [
  _hoisted_72
]
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_76 = { class: "task-event" }
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Task Events", -1))
const _hoisted_78 = {
  key: 1,
  class: "loading-container"
}
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, null, -1))
const _hoisted_80 = [
  _hoisted_79
]

import Modal from '@/components/Modal.vue';
import TaskEventInline from '@/components/TaskEventInline.vue';
import UserBadge from '@/components/UserBadge.vue';
import TaskInline from '@/components/TaskInline.vue'
import TimeSince from '@/components/TimeSince.vue';
import DateTimeBadge from '@/components/DateTimeBadge.vue';
import { TaskPriority } from '@/types/Ops';
import { useOpsSupplementStore } from '@/stores/OpsSupplement';
import { useTaskStore } from '@/stores/Tasks';
import { useEmployeeStore } from '@/stores/UserEmployee';
import { storeToRefs } from 'pinia';
import { computed, ref, watch, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { fetchTaskById } from '@/api/api';

enum SaveState {
  NoChanges = 0,
  Changed = 1,
  Saving = 2,
  SaveFailed = 3,
  Saved = 4
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TaskView',
  setup(__props) {

const editState = ref(false);
const taskStore = useTaskStore();
const employeeStore = useEmployeeStore();
const { employees, currentUser } = storeToRefs(employeeStore);
const opsSupp = useOpsSupplementStore();
const { work_centers } = storeToRefs(opsSupp);
const route = useRoute();
const taskId = ref(parseInt(route.params.id as string));

const task = computed(() => taskStore.getTaskById(taskId.value));
const selectedWorkCenter = ref(task.value?.work_center?.id || null);
const startedById = computed(() => task.value?.started_by ?? -1);
const createdById = computed(() => task.value?.created_by ?? -1);

const isCurrentUserAssignedToTask = computed(() => {
  const assignedUserIds = task.value?.assignments.map(assignment => assignment.user);
  return assignedUserIds?.includes(currentUser.value.id);
});

function truncateMilliseconds(durationStr) {
  return durationStr ? durationStr.split('.')[0] : '00:00:00';
}

const saved = ref<SaveState>(SaveState.NoChanges);

const formattedTaskDuration = computed(() => {
  const duration = task.value?.total_active_duration;
  if (duration) {
    const durationStr = typeof duration === 'number' ? duration.toString() : duration;
    const durationSeconds = parseDurationToSeconds(durationStr);
    return convertSecondsToHHMMSS(durationSeconds);
  }
  return '00:00:00';
});

function parseDurationToSeconds(durationStr: string): number {
  const parts = durationStr.match(/(\d+):(\d+):(\d+)/);
  if (parts) {
    const hours = parseInt(parts[1], 10);
    const minutes = parseInt(parts[2], 10);
    const seconds = parseInt(parts[3], 10);
    return hours * 3600 + minutes * 60 + seconds;
  }
  return 0;
}

function convertSecondsToHHMMSS(seconds) {
  const pad = (num) => String(num).padStart(2, '0');
  const hours = pad(Math.floor(seconds / 3600));
  const minutes = pad(Math.floor((seconds % 3600) / 60));
  const secs = pad(seconds % 60);
  return `${hours}:${minutes}:${secs}`;
}

const lastEventType = computed(() => {
  const lastEvent = task.value?.events.slice(-1)[0]?.event_type || '';
  return lastEvent;
});

watch(() => task, (nextTask, lastTask) => {
  if (lastTask.value != undefined)
    saved.value = SaveState.Changed;
}, { deep: true })

watch(() => route.params, (nextParam, lastParam) => {
  taskId.value = parseInt(nextParam.id as string);
});

watch(() => task.value, (newTaskValue) => {
  selectedWorkCenter.value = newTaskValue?.work_center?.id || null;
});

watch(() => task.value?.events, () => {
  // The logic here will now just update the lastEventType
  // console.log("Last event type:", lastEventType.value);
}, { deep: true });

const getWorkCenterName = (workCenterId: number | null) => {
  const wc = work_centers.value.find(w => w.id === workCenterId);
  return wc ? wc.name : 'None';
};

const priorityLabel = computed(() => {
  switch (task.value?.priority) {
    case TaskPriority.Low:
      return 'Low';
    case TaskPriority.Medium:
      return 'Medium';
    case TaskPriority.High:
      return 'High';
    default:
      return 'Not Set';
  }
});


onMounted(async () => {
  await employeeStore.fetch();
  await opsSupp.fetch();
  try {
    if (!taskStore.isLoadingTaks) {
      await taskStore.fetch();
    }
    const taskDetails = await fetchTaskById(taskId.value);
    selectedWorkCenter.value = taskDetails.work_center ? taskDetails.work_center.id : null;
    // console.log("Initial task value after fetching: ", task.value);
  } catch (error) {
    console.error("Error fetching task details: ", error);
  }
});

const updateWorkCenter = async () => {
  try {
    if (selectedWorkCenter.value !== null) {
      taskStore.updateWorkCenter(taskId.value, selectedWorkCenter.value);
    }
  } catch (error) {
    console.error("Error updating work center: ", error);
  }
};

const modifyAssignment = async (event: Event, uid: number) => {
  let newAssignment = task.value.assignments.map(a => a.user);
  let existing = newAssignment.findIndex(auid => auid == uid);
  if ((event.target as HTMLInputElement).checked && existing < 0) {
    newAssignment.push(uid);
  } else if (!(event.target as HTMLInputElement).checked && existing >= 0) {
    newAssignment.splice(existing, 1);
  }
  await taskStore.setAssignment(taskId.value, newAssignment);
}

const save = () => {
  editState.value = false;
  saved.value = SaveState.Saving;
  taskStore.save(taskId.value)
    .then(() => {
      console.log("Task was successfully saved.");
      saved.value = SaveState.Saved;
    }, (error) => {
      console.error("Error while saving task:", error);
      editState.value = true;
      saved.value = SaveState.SaveFailed;
    });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_unref(taskStore).isLoadingTaks)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h1", _hoisted_4, _toDisplayString(task.value?.id + " |"), 1)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              (_unref(employeeStore).currentUser.user?.is_superuser || (_unref(employeeStore).currentUser.user?.is_staff && !_unref(employeeStore).currentUser.user?.is_superuser))
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-check-input",
                      id: "editswitch",
                      type: "checkbox",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((editState).value = $event))
                    }, null, 512), [
                      [_vModelCheckbox, editState.value]
                    ]),
                    _hoisted_8
                  ]))
                : _createCommentVNode("", true),
              (task.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("h1", null, [
                          _withDirectives(_createElementVNode("input", {
                            class: "task-name-input",
                            disabled: !editState.value,
                            type: "text",
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((task.value.name) = $event))
                          }, null, 8, _hoisted_12), [
                            [_vModelText, task.value.name]
                          ])
                        ]),
                        _hoisted_13,
                        _withDirectives(_createElementVNode("textarea", {
                          class: "task-description-textarea",
                          disabled: !editState.value,
                          oninput: "this.style.height = \"\";this.style.height = this.scrollHeight + \"px\"",
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((task.value.description) = $event))
                        }, null, 8, _hoisted_14), [
                          [_vModelText, task.value.description]
                        ])
                      ])
                    ]),
                    _hoisted_15,
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("div", _hoisted_18, [
                          _hoisted_19,
                          _createElementVNode("div", _hoisted_20, [
                            _createElementVNode("b", null, _toDisplayString(priorityLabel.value), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_21, [
                          _hoisted_22,
                          _createElementVNode("div", _hoisted_23, [
                            _createElementVNode("b", null, _toDisplayString(task.value.job_name ? task.value.job_name : 'N/A'), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_24, [
                          _hoisted_25,
                          (task.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                _createVNode(UserBadge, { "user-id": createdById.value }, null, 8, ["user-id"])
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_27, [
                          _hoisted_28,
                          (task.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                _createVNode(UserBadge, { "user-id": startedById.value }, null, 8, ["user-id"])
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _hoisted_30,
                        _createElementVNode("div", _hoisted_31, [
                          _hoisted_32,
                          _createElementVNode("div", _hoisted_33, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(task.value.assignments, (assignment) => {
                              return (_openBlock(), _createElementBlock("span", {
                                key: assignment.id,
                                class: "userBadgeContainer"
                              }, [
                                (assignment?.user)
                                  ? (_openBlock(), _createBlock(UserBadge, {
                                      key: 0,
                                      "user-id": assignment?.user
                                    }, null, 8, ["user-id"]))
                                  : _createCommentVNode("", true)
                              ]))
                            }), 128)),
                            _createElementVNode("span", _hoisted_34, [
                              _createVNode(Modal, {
                                "show-button-text": editState.value ? '+' : undefined,
                                title: "Select Users"
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(task.value.assignments, (assignment) => {
                                    return (_openBlock(), _createElementBlock("span", {
                                      key: assignment.id,
                                      class: "userBadgeContainer"
                                    }, [
                                      (assignment?.user)
                                        ? (_openBlock(), _createBlock(UserBadge, {
                                            key: 0,
                                            "user-id": assignment?.user
                                          }, null, 8, ["user-id"]))
                                        : _createCommentVNode("", true)
                                    ]))
                                  }), 128)),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(employees), (us) => {
                                    return (_openBlock(), _createElementBlock("span", {
                                      class: "form-check",
                                      key: us.user.id
                                    }, [
                                      _createElementVNode("input", {
                                        class: "form-check-input",
                                        type: "checkbox",
                                        checked: task.value.assignments.find(assignment => assignment.user == us.user.id) ? true : false,
                                        onChange: (ev) => modifyAssignment(ev, us.user.id),
                                        id: 'user' + us.user.id
                                      }, null, 40, _hoisted_35),
                                      _createElementVNode("label", {
                                        class: "form-check-label",
                                        for: 'user' + us.user.id
                                      }, [
                                        _createVNode(UserBadge, {
                                          "user-id": us.user.id
                                        }, null, 8, ["user-id"])
                                      ], 8, _hoisted_36),
                                      _createTextVNode("+ ")
                                    ]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["show-button-text"])
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_37, [
                        _createElementVNode("div", _hoisted_38, [
                          _hoisted_39,
                          _createElementVNode("div", _hoisted_40, [
                            _withDirectives(_createElementVNode("select", {
                              class: "form-control border-0 customDropdown",
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((selectedWorkCenter).value = $event)),
                              disabled: !editState.value,
                              onChange: _cache[4] || (_cache[4] = event => { updateWorkCenter() }),
                              style: {"--bs-bg-opacity":"0.9"}
                            }, [
                              _hoisted_42,
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(work_centers), (wc) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  key: wc?.id,
                                  value: wc.id
                                }, _toDisplayString(wc.name), 9, _hoisted_43))
                              }), 128))
                            ], 40, _hoisted_41), [
                              [_vModelSelect, selectedWorkCenter.value]
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_44, [
                        _hoisted_45,
                        _createElementVNode("div", _hoisted_46, [
                          _createVNode(DateTimeBadge, {
                            time: task.value?.expected_start
                          }, null, 8, ["time"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_47, [
                        _hoisted_48,
                        _createElementVNode("div", _hoisted_49, [
                          _createVNode(DateTimeBadge, {
                            time: task.value.started
                          }, null, 8, ["time"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_50, [
                        _hoisted_51,
                        _createElementVNode("div", _hoisted_52, [
                          _createVNode(DateTimeBadge, {
                            time: task.value?.expected_concluded
                          }, null, 8, ["time"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_53, [
                        _hoisted_54,
                        _createElementVNode("div", _hoisted_55, [
                          _createVNode(DateTimeBadge, {
                            time: task.value.concluded
                          }, null, 8, ["time"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_56, [
                        _hoisted_57,
                        _createElementVNode("div", _hoisted_58, _toDisplayString(truncateMilliseconds(task.value.total_active_duration)), 1)
                      ]),
                      (_unref(employeeStore).currentUser.user?.is_superuser)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                            _hoisted_60,
                            _createElementVNode("div", _hoisted_61, " $" + _toDisplayString(task.value?.labor_cost), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_62, [
                      _createElementVNode("button", {
                        class: "btn btn-primary customSaveButton",
                        onClick: save
                      }, "Save"),
                      (saved.value == SaveState.Saving)
                        ? (_openBlock(), _createElementBlock("button", _hoisted_63, "Saving..."))
                        : _createCommentVNode("", true),
                      (saved.value == SaveState.Saved)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_64, "Saved"))
                        : _createCommentVNode("", true),
                      (saved.value == SaveState.SaveFailed)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_65, "Save Failed"))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _hoisted_66,
            (isCurrentUserAssignedToTask.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                  (taskId.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                        _hoisted_69,
                        _createElementVNode("div", null, [
                          _createVNode(TaskInline, { taskId: taskId.value }, null, 8, ["taskId"]),
                          (task.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                                _createElementVNode("b", null, [
                                  _createVNode(TimeSince, {
                                    duration: formattedTaskDuration.value,
                                    eventType: lastEventType.value,
                                    taskId: task.value.id
                                  }, null, 8, ["duration", "eventType", "taskId"])
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_71, _hoisted_73))
                ]))
              : _createCommentVNode("", true),
            _hoisted_74,
            _hoisted_75,
            _createElementVNode("div", _hoisted_76, [
              _hoisted_77,
              _createVNode(TaskEventInline, {
                events: task.value?.events || []
              }, null, 8, ["events"])
            ])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_78, _hoisted_80))
  ]))
}
}

})